import React from "react";
import { useNavigate } from "react-router-dom";
import * as routes from "../../../routes";
import { formatTime } from "../../../Utils/timeUtlil";
import { STATUS } from "../../../Constants/Strings";

const DayCard = ({ data }) => {
    const navigate = useNavigate();
    const formatStatus = (status) => {
        const text = status.replace(/_/g, " ");
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    return (
      <div className="bg-white  p-4 w-full md:min-w-[280px] md:max-w-[300px] md:flex-1 flex flex-col justify-between border-b-2 md:border-r-2 cursor-pointer hover:bg-gray-50 transition"
        onClick={() => navigate(routes.VIEW_DAY.replace(":dayId", data.id))}
      >
        <div className="flex justify-between items-start mb-4">
          <div className="flex flex-col gap-1 max-w-[60%]">
            <p className="text-base font-semibold text-gray-800 truncate max-w-[10rem]">
              {data.user_name}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              {data.created?.split("T")[0]}
            </p>
          </div>

          <div className="flex flex-col items-end gap-2">
            <span
              className={`text-xs font-semibold px-3 py-1 rounded-full ${
                data.status === STATUS.COMPLETED
                  ? "bg-green-100 text-green-700"
                  : data.status === STATUS.IN_PROGRESS
                  ? "bg-yellow-100 text-yellow-800"
                  : data.status === STATUS.COMPLETED_BY_ADMIN
                  ? "bg-blue-100 text-blue-700"
                  :"bg-gray-100 text-gray-600" 
              }`}
            >
              {formatStatus(data.status)}
            </span>
          </div>
        </div>

        <div className="text-sm text-gray-600">
          <span className="font-medium">Time:</span>{" "}
          {formatTime(data.start_time)}
          {data.status !== STATUS.IN_PROGRESS && (
            <>
              &nbsp;|&nbsp;<span>{formatTime(data.end_time)}</span>
            </>
          )}
        </div>
      </div>
    );
};

export default DayCard;
